import { useRouter } from 'next/router';

import { Box, Heading, Paragraph } from '@zillow/constellation-10';

import { useGetListingRecommendations } from '../../../../hooks/queries/properties';

import { REVIEW_PAGE_SECTIONS } from '../../../../constants/ListingDetailConstants';
import { RECS } from '../../../../constants/RecommendationsConstants';

import {
  wizardFlexContainerStyles,
  wizardFormSectionContainerStyles,
  wizardHeadingStyles,
  wizardParagraphStyles,
} from '../../../../styles/wizard';

import PetPolicyFormField from '../../../PostingPath/PetPolicyFormField';
import PageWizard from '../../../Wizard/PageWizard';
import WizardTipCardContainer from '../../../WizardTipCardContainer';

import type { WizardBodyTemplateProps } from '../../../WizardStepController';

const PetPolicy = ({
  onGoToNextStep,
  onGoToPrevStep,
  onExitWizard,
  wizardTitle,
  progressStepper,
  totalSteps,
  currentStepIndex,
  showDesktopViewBreakpoint,
  ...rest
}: WizardBodyTemplateProps) => {
  const router = useRouter();
  const listingAlias = router.query.listingAlias as string;

  const { recommendationsBySection } = useGetListingRecommendations({
    listingAlias,
    isMultifamily: false,
  });

  const petsRec = recommendationsBySection[REVIEW_PAGE_SECTIONS.RENT_DETAILS]?.[RECS.PETS_NOT_ALLOWED];

  return (
    <PageWizard
      {...rest}
      title=""
      wizardTitle={wizardTitle}
      progressStepper={progressStepper}
      totalSteps={totalSteps}
      currentStepIndex={currentStepIndex}
      onNextClick={onGoToNextStep || undefined}
      onBackClick={onGoToPrevStep || undefined}
      onExitTriggered={onExitWizard}
      showDesktopViewBreakpoint={showDesktopViewBreakpoint}
    >
      <Box css={wizardFlexContainerStyles}>
        <Box>
          <Box css={wizardFormSectionContainerStyles.raw()}>
            <Heading level={2} textStyle="heading-sm" css={wizardHeadingStyles}>
              What’s your pet policy?
            </Heading>

            <Paragraph css={wizardParagraphStyles}>Let renters know if you allow pets and, if so, what kind.</Paragraph>

            <PetPolicyFormField />
          </Box>

          {!!petsRec?.outcomeStats && (
            <WizardTipCardContainer
              header="Consider allowing pets"
              showDesktopViewBreakpoint={showDesktopViewBreakpoint}
            >
              <Paragraph>
                Properties that allow pets can receive up to {petsRec?.outcomeStats}% more contacts than those that
                don’t. This is based on data for other listings with a similar price.
              </Paragraph>
              <Paragraph textStyle="body-xs" color="text.subtle" css={{ marginTop: '400' }}>
                {petsRec?.source?.tip}
              </Paragraph>
            </WizardTipCardContainer>
          )}
        </Box>
      </Box>
    </PageWizard>
  );
};

export default PetPolicy;
